<template>
  <div>
    <label class="label" :class="{ 'required': required, 'nowrap': inlineLabel }">
      {{ label }}
    </label>

    <v-text-field ref="textfield" outlined dense :rules="rules" v-model="inputValue" @input="valueChanged"
      @keyup.enter="$emit('enter')" :disabled="disabled" :readonly="readonly" :type="type" :hint="hint" :prefix="prefix"
      :prepend-inner-icon="prepend_icon" :append-icon="append_icon" @blur="$emit('blur')"
      @click:append="$emit('eventAppendIconClicked')" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: "",
    },
    label: {
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {},
    type: {
      default: "text",
    },
    hint: {},
    prepend_icon: {
      default: "",
    },
    prefix: {
      default: "",
    },
    append_icon: {
      default: "",
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
    inlineLabel: {
      type: Boolean,
      default: false,
    },
    nospace: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      inputValue: this.value,
    };
  },

  watch: {
    value(val) {
      this.inputValue = val;
    },
  },

  methods: {
    valueChanged(val) {

      const input = this.$refs.textfield?.$el?.querySelector('input');

      let cursorPosition = null;

      if (input && typeof input.selectionStart === 'number') {
        cursorPosition = input.selectionStart;
      }

      let value = val || "";

      if (this.nospace) {
        value = value.replace(/\s/g, "");
      }

      if (this.uppercase) {
        value = value.toUpperCase();
      }

      this.inputValue = value;

      this.$emit("input", value);

      this.$nextTick(() => {

        if (
          input &&
          cursorPosition !== null &&
          document.contains(input) &&
          !input.disabled &&
          input.type !== 'number'
        ) {
          try {
            input.setSelectionRange(
              cursorPosition,
              cursorPosition
            );
          } catch (e) {
            // ignore
          }
        }
      });
    }
  },
};
</script>